<template>
  <div class="my_service">
    <van-collapse v-model="host" :border="false" class="service_item se1">
      <van-collapse-item name="1">
        <template #title>
          <div class="item_top">
            <i class="iconfont icon-zixun1 kf1"></i>
            <div class="top_text">
              <p class="text_h1">Contact Organzier</p>
              <p>Consultation on exhibition related issues</p>
            </div>
          </div>
        </template>
        <div class="item_con" v-if="hostList.length">
          <div class="kf_item" v-for="(item, index) in hostList" :key="index">
            <div class="kf_left">
              <p class="name">
                {{ item.fullName }}<span>{{ item.title }}</span>
              </p>
              <p class="phone">
                Email:<span>{{ item.email }}</span>
              </p>
              <!-- <p>
                QQ：<span>{{ item.qQId }}</span>
              </p> -->
            </div>
            <div class="ke_right" v-if="item.weChatQrCode">
              <img :src="item.weChatQrCode" v-load="'oPic'"  />
              <!-- <p>长按识别二维码</p> -->
            </div>
          </div>
        </div>
        <p class="no-msg" v-else style="font-size: 0.26rem">no data</p>
      </van-collapse-item>
    </van-collapse>
    <van-collapse
      v-model="zsx"
      :border="false"
      v-if="false"
      class="service_item"
    >
      <van-collapse-item name="1">
        <template #title>
          <div class="item_top">
            <i class="iconfont icon-zixun2 kf2"></i>
            <div class="top_text">
              <p class="text_h1">联系云展台客服</p>
              <p>咨询云展台系统使用问题</p>
            </div>
          </div>
        </template>
        <div class="item_con" v-if="zsxList.length">
          <div class="kf_item" v-for="(item, index) in zsxList" :key="index">
            <div class="kf_left">
              <p class="name">
                {{ item.fullName }}<span>{{ item.title }}</span>
              </p>
              <p class="phone">
                手机：<span>{{ item.phoneNumber }}</span>
              </p>
              <p>
                QQ：<span>{{ item.qQId }}</span>
              </p>
            </div>
            <div class="ke_right" v-if="item.weChatQrCode">
              <img :src="item.weChatQrCode" v-load="'oPic'"  />
              <p>长按识别二维码</p>
            </div>
          </div>
        </div>
        <p class="no-msg" v-else style="font-size: 0.26rem">暂无数据</p>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>
<script>
import gql from "graphql-tag";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { List } from "vant";
export default {
  name: "my-service",
  components: {},
  data() {
    return {
      host: ["1"],
      zsx: ["1"],
      hostList: [],
      zsxList: [],
      getHostCustomerServices: {}, //主办客服
      getCustomerServices: {}, //展商秀客服
    };
  },
  async created() {
    this.$store.commit("setExhibitionId", this.$route.params.id);
    if (!this.userInfo) {
      await this.$Myapollo.getUserInfo(this);
    }
    this.$Myapollo.addExhibitionView();
    this.getHostService();
    this.getZsxService();
  },
  mounted() {},
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId: "getExhibitionId",
    }),
  },
  methods: {
    ...mapActions({}),
    getHostService() {
      let query = gql`
        query getHostCustomerServices($exhibitionId: Guid!) {
          getHostCustomerServices(exhibitionId: $exhibitionId) {
            fullName
            fullNameEn
            titleEn
            phoneNumber
            qQId
            title
            weChatQrCode
            email
          }
        }
      `;
      this.$apollo.addSmartQuery("getHostCustomerServices", {
        query: query,
        variables: {
          exhibitionId: this.exhibitionId,
        },
        fetchPolicy: "network-only", //清理缓存
        result(data) {
          let res = JSON.parse(
            JSON.stringify(data.data.getHostCustomerServices)
          );
          // let res=data.data.queryProduct;
          console.log("主办客服", res);
          this.hostList = res;
        },
        error(err) {
          console.log("err", err);
        },
      });
    },
    getZsxService() {
      let query = gql`
        query getCustomerServices {
          getCustomerServices {
            fullName
            phoneNumber
            qQId
            title
            weChatQrCode
          }
        }
      `;
      this.$apollo.addSmartQuery("getCustomerServices", {
        query: query,
        variables: {},
        fetchPolicy: "network-only", //清理缓存
        result(data) {
          let res = JSON.parse(JSON.stringify(data.data.getCustomerServices));
          // let res=data.data.queryProduct;
          console.log("展商秀客服", res);
          this.zsxList = res;
        },
        error(err) {
          console.log("err", err);
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.my_service {
  background: #f2f2f2;
  min-height: 100vh;
  ::v-deep .service_item {
    &.se1 {
      margin-bottom: 0.3rem;
    }
    .van-collapse-item {
      .van-cell {
        align-items: center;
        padding: 0.3rem;
        &::after {
          left: 0.3rem;
          right: 0.3rem;
        }

        .item_top {
          display: flex;
          height: 0.8rem;
          align-items: center;
          .top_text {
            p {
              color: #999;
              &.text_h1 {
                color: #333;
                font-size: 0.3rem;
              }
            }
          }
          .iconfont {
            font-size: 0.46rem;
            transform: scale(1.5);
            margin-right: 0.3rem;
            &.kf1 {
              color: #1890ff;
            }
            &.kf2 {
              color: #fc7b7f;
            }
          }
        }
      }
      .van-collapse-item__wrapper {
        .van-collapse-item__content {
          padding: 0.3rem;
          .item_con {
            .kf_item {
              margin-bottom: 0.2rem;
              background: #f5f5f5;
              padding: 0.25rem;
              height: 1.8rem;
              display: flex;
              justify-content: space-between;
              align-items: center;
              &:last-child {
                margin-bottom: 0;
              }
              .kf_left {
                color: #666;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                * {
                  font-size: 0.26rem;
                  color: #666;
                }
                .phone {
                  span {
                    color: #1890ff;
                  }
                }
                .name {
                  color: #262626;
                  font-size: 0.3rem;
                  margin-bottom: .1rem;
                  display: flex;
                  align-items: flex-end;
                  span {
                    transform: translateY(-0.06rem);
                    margin-left: 0.1rem;
                    font-size: 0.18rem;
                    color: #666;
                  }
                }
              }
              .ke_right {
                text-align: center;
                img {
                  width: 0.8rem;
                  height: 0.8rem;
                }
                p {
                  color: #999;
                  font-size: 0.18rem;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
